module.exports = __webpack_public_path__ + "static/media/page-0001.0990d68f.jpg";